export default "__VITE_ASSET__CSHJAxYU__"